import { useQuery } from '@tanstack/react-query'

import { getEvidencesCount } from '@src/api'
import { DefaultApiGetEvidencesCountRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchEvidencesCount = (
  params: DefaultApiGetEvidencesCountRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getEvidencesCount(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_EVIDENCES_COUNT, params],
  })
}
